import { EventEmitter } from '@root/Services/EventEmitter';

/**
 * Simple calculator for a virtual render area
 */
export class VirtualRenderArea {
    private _scrollPos = 0;
    private _viewerHeight = 0;
    private _itemCount = 0;
    private _itemHeight = 0;
    private _visibleCount = 0;
    private _visibleStart = 0;
    private _topBuffer = 0;
    private _totalHeight = 0;

    public stateChanged = EventEmitter.empty();

    public set itemHeight(value: number) {
        if (this._itemHeight !== value) {
            this._itemHeight = value;
            this.invalidateViewRange();
            this.invalidateTotalHeight();
            this.invalidateScrollPos();
        }
    }
    public get itemHeight() {
        return this._itemHeight;
    }

    public set itemCount(value: number) {
        if (this._itemCount !== value) {
            this._itemCount = value;
            this.invalidateViewRange();
            this.invalidateTotalHeight();
        }
    }
    public get itemCount() {
        return this._itemCount;
    }

    public set scrollPos(value: number) {
        if (this._scrollPos !== value) {
            this._scrollPos = value;
            this.invalidateViewRange();
        }
    }
    public get scrollPos() {
        return this._scrollPos;
    }

    public set viewerHeight(value: number) {
        if (this._viewerHeight !== value) {
            this._viewerHeight = value;
            this.invalidateViewRange();
            this.invalidateScrollPos();
        }
    }
    /**
     * Height of the scrollable container
     */
    public get viewerHeight() {
        return this._viewerHeight;
    }

    /**
     * Number of items visible, based on the height of the scrollable container
     */
    public get visibleCount() {
        return this._visibleCount;
    }
    public get visibleStart() {
        return this._visibleStart;
    }
    /**
     * Total height of items above the visible range, based on scroll position
     */
    public get topBuffer() {
        return this._topBuffer;
    }
    /**
     * Total height of items, itemHeight * itemCount
     */
    public get totalHeight() {
        return this._totalHeight;
    }

    private invalidateViewRange() {
        const maxItems = Math.ceil(this._viewerHeight / this._itemHeight) + 1;

        this._visibleStart = Math.floor(this._scrollPos / this._itemHeight);
        this._visibleCount = Math.min(this._itemCount - this._visibleStart, maxItems);
        this._topBuffer = this._visibleStart * this._itemHeight;
        this.stateChanged.emit();
    }

    private invalidateTotalHeight() {
        this._totalHeight = this._itemHeight * this._itemCount;
        this.stateChanged.emit();
    }

    private invalidateScrollPos() {
        this._scrollPos = Math.min(Math.max(0, this._totalHeight - this._viewerHeight), this._scrollPos);
        this.stateChanged.emit();
    }
}
